
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order-personal-videos/[id]",
      function () {
        return require("private-next-pages/order-personal-videos/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order-personal-videos/[id]"])
      });
    }
  